























































































































import {Component, Vue} from 'vue-property-decorator'
import Overlay from '@/components/common/Overlay.vue'
import {Getter, Mutation, Action} from 'vuex-class'
import {InventoryItem as InventoryItemInterface, ItemType, Room} from '@/store/types'
import InventoryItem from '@/components/inventory/InventoryItem.vue'
import ToggleButton from 'vue-js-toggle-button/src/Button.vue'
import LeadRoomInventoryModel from '@/classes/LeadRoomInventoryModel'
import LengthFormatter from '@/classes/LengthFormatter'
import Errors from '@/classes/Errors'
import AppHeader from '@/components/common/AppHeader.vue'
import AppFooter from '@/components/common/AppFooter.vue'

@Component({
  components: {
    Overlay,
    InventoryItem,
    ToggleButton,
    AppHeader,
    AppFooter,
  },
})
export default class InventoryEditItemOverlay extends Vue {
  @Getter('activeItem') public activeItem!: InventoryItemInterface
  @Getter('itemTypes') public itemTypes!: ItemType[]
  @Getter('activeRoom') public activeRoom!: Room
  @Mutation('setInventoryEditItemOverlay') public setInventoryEditItemOverlay!: any
  @Mutation('resetActiveItem') public resetActiveItem!: any
  @Action('editRoomItem') public editRoomItem!: any
  @Action('removeRoomItem') public removeRoomItem!: any

  public LengthFormatter = LengthFormatter
  public LeadRoomInventoryModel: any = LeadRoomInventoryModel
  public errors = new Errors()
  public isCustom: boolean = false
  public isCustomQuantity: boolean = false
  public packing: number = LeadRoomInventoryModel.PACKED_BY.MOVERS
  public crate: boolean = false
  public quantity: number = 1
  public volume: number = 0
  public width: any = null
  public height: any = null
  public depth: any = null
  public measureUnit: string = LengthFormatter.UNIT.INCH

  public get calculatedVolume() {
    if (this.customDimensions) {
      let vol = Math.round(parseFloat(this.width) * parseFloat(this.height) * parseFloat(this.depth))
      if (this.measureUnit === LengthFormatter.UNIT.INCH) {
        vol = Math.round(LengthFormatter.inchToFoot(this.width) *
          LengthFormatter.inchToFoot(this.height) * LengthFormatter.inchToFoot(this.depth))
      }
      return vol > 0 ? vol : 1
    }
    if (this.volume) {
      return this.volume
    }
    const type = this.itemTypes.find((i) => i.id === this.activeItem.inventory_id)
    if (type !== undefined) {
      return this.activeItem.volume
    }
    return 1
  }

  public get activeRoomName() {
    if (this.activeRoom) {
      return !!this.activeRoom.name ? this.activeRoom.name : this.activeRoom.room.name
    }
  }

  public get customDimensions() {
    return (this.crate ||
      !(this.width === null || this.width === '') ||
      !(this.height === null || this.height === '') ||
      !(this.depth === null || this.depth === ''))
  }

  public get dimensionsValid() {
    return this.width * 1 && this.height * 1 && this.depth * 1
  }

  public closeCustomQuantity() {
    this.isCustomQuantity = false
  }

  public clearCustomDimensions() {
    this.width = ''
    this.height = ''
    this.depth = ''
  }

  public resetCustomDimensions() {
    if (this.dimensionsValid && !this.isCustom) {
      this.clearCustomDimensions()
    }
  }

  public dimensionInput() {
    if (this.dimensionsValid) {
      this.volume = this.calculatedVolume
    }
    this.clearErrors()
  }

  public switchPacking(packing: number) {
    this.packing = packing
  }

  public switchMeasureUnit(unit: string) {
    if (this.measureUnit === unit) {
      return
    }
    this.measureUnit = unit
    if (this.measureUnit === LengthFormatter.UNIT.INCH) {
      this.width = LengthFormatter.footToInch(this.width)
      this.height = LengthFormatter.footToInch(this.height)
      this.depth = LengthFormatter.footToInch(this.depth)
    }
    if (this.measureUnit === LengthFormatter.UNIT.FOOT) {
      this.width = LengthFormatter.inchToFoot(this.width)
      this.height = LengthFormatter.inchToFoot(this.height)
      this.depth = LengthFormatter.inchToFoot(this.depth)
    }
  }

  public increaseQuantity() {
    this.quantity++
  }
  public decreaseQuantity() {
    if (this.quantity > 1) {
      this.quantity--
    }
  }

  public clearErrors() {
    this.errors.clear()
  }

  public editItem() {
    if (this.customDimensions && !this.dimensionsValid) {
      let errors = {}
      if (!(this.width * 1)) {
        errors = Object.assign(errors, {width: ['width is required']})
      }
      if (!(this.height * 1)) {
        errors = Object.assign(errors, {height: ['height is required']})
      }
      if (!(this.depth * 1)) {
        errors = Object.assign(errors, {depth: ['depth is required']})
      }
      this.errors.record(errors)
      return
    }
    const data: any = {
      id: this.activeItem.id,
      quantity: this.quantity,
      packed_by: this.packing,
      to_be_crated: this.crate,
      custom_dimensions: this.customDimensions,
      volume: this.calculatedVolume,
    }
    if (this.customDimensions && this.dimensionsValid) {
      let dimensions
      if (this.measureUnit === LengthFormatter.UNIT.FOOT) {
        dimensions = {
          width: LengthFormatter.footToInch(this.width),
          height: LengthFormatter.footToInch(this.height),
          depth: LengthFormatter.footToInch(this.depth),
        }
      } else {
        dimensions = {
          width: this.width,
          height: this.height,
          depth: this.depth,
        }
      }
      Object.assign(data, dimensions)
    }

    this.editRoomItem(data).then((response: InventoryItemInterface) => {
      this.resetActiveItem()
      this.setInventoryEditItemOverlay(false)
    })
  }

  public deleteItem() {
    this.removeRoomItem(this.activeItem).then((response: any) => {
      this.resetActiveItem()
      this.setInventoryEditItemOverlay(false)
    })
  }

  public back() {
    this.resetActiveItem()
    this.setInventoryEditItemOverlay(false)
  }

  public setup() {
    this.quantity = this.activeItem.quantity
    this.volume = this.activeItem.volume
    this.packing = this.activeItem.packed_by
    this.crate = this.activeItem.to_be_crated > 0
    this.isCustom = (this.activeItem.inventory_id === 1)

    if (this.activeItem.width) {
      this.width = this.activeItem.width
    }
    if (this.activeItem.height) {
      this.height = this.activeItem.height
    }
    if (this.activeItem.depth) {
      this.depth = this.activeItem.depth
    }
    this.switchMeasureUnit(LengthFormatter.UNIT.INCH)
  }

  public mounted() {
    this.setup()
  }
}
